import { FacebookLoginProvider } from '@/helpers/entities/classes/providers/FacebookLoginProvider';
import { ConsoleLogger } from '../logger/ConsoleLogger';
/**
 * Fetch Facebook Account Details via Facebook API Graph
 * https://developers.facebook.com/docs/javascript/reference/FB.api
 */
export default class PageListFetcher {
    constructor(token, endpoint, requestType) {
        this.token = token;
        this.endpoint = endpoint;
        this.requestType = requestType;
        this.pages = [];
        this.action = 'get';
    }
    async fetch() {
        const params = { access_token: this.token };
        const logger = new ConsoleLogger();
        return new Promise((resolve, reject) => {
            // Commented to initialize the FB SDK Initializer on mounted hook
            // this.initializeFacebookSdk().then(() => {
            // Wrap Facebook Graph API request inside `then()` to ensure Facebook
            //  SDK were loaded before we send our request.
            FB.api(this.endpoint, this.action, params, (response) => {
                // Reason why we set `response` to any ? Simply because this is a
                // callback function from Facebook Graph API and this response may
                // contain either error or data;
                // https://developers.facebook.com/docs/javascript/reference/FB.api
                if (!response || response.error) {
                    logger.error(response);
                    reject(response.error);
                }
                else if (!response.accounts && this.requestType === 'default') {
                    const err = new Error('No Pages');
                    reject(err);
                }
                else if (!response.data && this.requestType === 'page') {
                    const err = new Error('No Pages');
                    reject(err);
                }
                else {
                    if (this.requestType === 'default') {
                        resolve({ data: response.accounts.data, pagination: response.accounts.paging });
                    }
                    if (this.requestType === 'page') {
                        resolve({ data: response.data, pagination: response.paging });
                    }
                }
            });
        });
        // });
    }
    // For reuse to check if FB.init function is working
    async initializeFacebookSdk() {
        // Initialize Facebook Instance in FacebookLoginProvider
        await new FacebookLoginProvider().initialize();
    }
}
